<ol class="breadcrumb">
  <li *ngFor="let breadcrumb of service.breadcrumbs" [ngClass]="{'active': breadcrumb.active}">
    <a *ngIf="breadcrumb.url" [routerLink]="breadcrumb.url">{{breadcrumb.label}}</a>
    <span *ngIf="!breadcrumb.url">{{breadcrumb.label}}</span>
  </li>
</ol>
